export default __webpack_public_path__ + "static/media/trailer_2_3.7035cb73.svg";